// STEP 5-CT-D · CS 택배조회 준비 UI (외부 API 미연동 · 정적 링크만)
// - 신규 DB field 없음 · 기존 shipment/shipments/delivery_status 만으로 판단
// - 확실한 공식 배송조회 URL 만 매핑 (불확실한 URL 은 null → UI 는 "준비중" 표시)
// - 향후 실 API 연동 시 이 파일의 매핑만 확장하면 CS UI 는 변경 없이 동작

// 공식 배송조회 URL 정적 매핑. 매핑 없는 택배사는 null → "준비중" 처리.
// 매핑을 추가할 때는 반드시 공식 홈페이지의 공개 조회 URL 만 사용.
const TRACKING_URL_TEMPLATES = {
  'CJ대한통운': (t) => `https://trace.cjlogistics.com/next/tracking.html?wblNo=${encodeURIComponent(t)}`,
  'CJ Logistics': (t) => `https://trace.cjlogistics.com/next/tracking.html?wblNo=${encodeURIComponent(t)}`,
  '우체국택배': (t) => `https://service.epost.go.kr/trace.RetrieveDomRigiTraceList.comm?sid1=${encodeURIComponent(t)}`,
  '롯데택배': (t) => `https://www.lotteglogis.com/home/reservation/tracking/linkView?InvNo=${encodeURIComponent(t)}`,
  '한진택배': (t) => `https://www.hanjin.co.kr/kor/CMS/DeliveryMgr/WaybillResult.do?mCode=MN038&wblnumText2=${encodeURIComponent(t)}`,
  '로젠택배': (t) => `https://www.ilogen.com/web/personal/trace/${encodeURIComponent(t)}`,
};

// 택배사 이름 normalise (앞뒤 공백 · (TEST) prefix 제거 · 소문자 무관 매칭)
const normaliseCarrier = (c) => {
  if (!c) return '';
  return String(c).replace(/\(TEST\)/gi, '').replace(/^\s+|\s+$/g, '');
};

// 배송조회 가능 여부: 송장번호 + 택배사 매핑 존재 시 true.
export const getTrackingAvailable = (courier, trackingNumber) => {
  const key = normaliseCarrier(courier);
  const tn = (trackingNumber || '').toString().trim();
  if (!key || !tn) return false;
  return Boolean(TRACKING_URL_TEMPLATES[key]);
};

// 공식 배송조회 URL (정적 매핑만 · 매핑 없는 경우 null).
export const getTrackingUrl = (courier, trackingNumber) => {
  const key = normaliseCarrier(courier);
  const tn = (trackingNumber || '').toString().trim();
  if (!key || !tn) return null;
  const tpl = TRACKING_URL_TEMPLATES[key];
  return tpl ? tpl(tn) : null;
};

// 파생 배송상태 (기존 shipment.delivered_at / shipped_at / delivery_status / order status 만 활용).
// 외부 실시간 조회 없음 — 향후 API 연동 시 이 함수만 확장.
export const getTrackingStatus = ({ shipment, delivery_status, orderStatus } = {}) => {
  const sh = shipment || {};
  if (sh.delivered_at) return '배송완료';
  if (delivery_status === 'delivered') return '배송완료';
  if (delivery_status === 'in_transit') return '배송중';
  if (delivery_status === 'pickup_done') return '집화완료';
  if (delivery_status === 'invoice_created') return '송장등록';
  if (sh.shipped_at) return '배송중';
  if (orderStatus === 'delivered') return '배송완료';
  if (orderStatus === 'shipping') return '배송중';
  if (orderStatus === 'preparing') return '배송준비';
  return null;
};

// STEP 3-OPS-C-HOTFIX · Carrier 실시간 tracking API가 연결되지 않은 현재
// "배송중" 처럼 실제 택배사 상태를 흉내내는 label 을 노출하지 않도록
// 내부 LIVEMOA 출고 흐름만 반영한 새 helper.
// - LIVEMOA 에서 delivered/confirmed 확인 → "배송완료"
// - 송장 존재 + LIVEMOA 출고 완료 → "출고완료" (Carrier 실 상태 아님)
// - 그 외 → null (label 숨김 · [배송조회 ↗] 로 실제 상태 확인)
// 신규 DB field 저장 없음. 기존 shipment/order status 필드만 활용.
export const getInternalShipmentLabel = ({ shipment, orderStatus, fulfillmentStatus } = {}) => {
  const sh = shipment || {};
  if (sh.delivered_at) return '배송완료';
  if (orderStatus === 'delivered' || orderStatus === 'confirmed') return '배송완료';
  const shipped = Boolean(sh.tracking_number) && (
    Boolean(sh.shipped_at) ||
    orderStatus === 'shipping' ||
    fulfillmentStatus === 'shipped'
  );
  if (shipped) return '출고완료';
  return null;
};
